import { render, staticRenderFns } from "./ConfirmVerify.vue?vue&type=template&id=52f08c3a&scoped=true"
import script from "./ConfirmVerify.vue?vue&type=script&lang=js"
export * from "./ConfirmVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f08c3a",
  null
  
)

export default component.exports